<template>
    <div class="segment-item" >
        <div class="row-number">
            {{rowNumber}}
        </div>
        <div class="text" >
            <SourceSegment :modelValue="modelValue.sourceData" />
        </div>
        <div class="text">
            <SourceSegment :modelValue="modelValue.draftData" />
        </div>
    </div>
</template>

<script lang="ts">
    import { defineComponent, PropType } from 'vue';

    import { TranslationSegment } from '@/models/TranslationSegment';

    import SourceSegment from '../Document/Segment/SourceSegmentView.vue'

    export default defineComponent({
        name: 'SegmentItemPreview',
        components: {
            SourceSegment,
        },
        props: {
            modelValue: {
                type: Object as PropType<TranslationSegment>,
                required: true
            },
            rowNumber: {
                type: Number,
                required: true
            }
        },
    })
</script>

<style lang="scss" scoped>
    .segment-item {
        padding: 12px;
        color: var(--text-color);
        width: 100%;
        box-sizing: border-box;
        display: grid;
        grid-template-columns: 1fr 8fr 8fr;
        transition: background-color 0.2s ease-in-out;

        &:hover {
            background-color: var(--light-blue-focused);
        }
    }
    .row-number {
        margin-top: 12px;
    }
    .text{
        max-width: 560px;
    }
</style>